import { render } from "./BarcodeScannerModal.vue?vue&type=template&id=2d3c95d2&scoped=true"
import script from "./BarcodeScannerModal.vue?vue&type=script&lang=js"
export * from "./BarcodeScannerModal.vue?vue&type=script&lang=js"

import "./BarcodeScannerModal.vue?vue&type=style&index=0&id=2d3c95d2&scoped=true&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3c95d2"]])

export default __exports__